module.exports = __webpack_public_path__ + "static/media/grandValleyFloorPlan2.fe78fa85.png";